import { useContext } from "react"
import { CartelasFornecedorContext } from "./CartelasFornecedorContext"

export function useCartelasFornecedorContext() {
    return useContext(CartelasFornecedorContext)
}
